import React, { useState, useEffect, useRef, useCallback } from "react";
import { Select, Button, Form, Modal, Input, message, Tabs, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getDropDownList, getPromptResponse, addNewFieldInDB, getTargetGroups, getCTAResponse } from "../../apis/MarketingSmsAPI";
import SessionTimeoutModal from "../../components/SessionTimeoutModal";
import loader from '../../assets/images/loader.gif';
import MessageTab from "./MessageTab"
import "./marketing.scss";
import useMarketingStore from "../../store/useMarketingStore";
import { useLocation } from "react-router-dom";
import { getTitleFromPath } from "../../libs/utilities/helpers/getTitle"
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import AssistantOutlinedIcon from "@mui/icons-material/AssistantOutlined";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import {
  setMarketingTabIndex,
  setMarketingPages,
} from "../../reducers/marketingSlice";
const { TextArea } = Input;
const { TabPane } = Tabs;
const { Option } = Select;

const campaignOptions = [
  { value: 'Engagement', label: 'Engagement' },
  { value: 'Cross Sell', label: 'Cross Sell' },
  { value: 'Policy Loan', label: 'Policy Loan' },
];

const Marketing = () => {
  const [formData, setFormData] = useState({
    campaign: '',
    category: '',
    subCategory: '',
    subCategoryDesc: '',
    product_name: '',
    bs_text: '',
    behavioralScienceCheck: false,
  });
  const [bucket, setBucket] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [bucketMap, setBucketMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [othersType, setOthersType] = useState(null);
  const [othersBucketInput, setOthersBucketInput] = useState("");
  const [othersSubCategoryInput, setOthersSubCategoryInput] = useState("");
  const [othersDesc, setOthersDesc] = useState("");
  const [generateLoading, setGenerateLoading] = useState(false);
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState({ bucket: "", subCategory: "", desc: "" });
  const [modalTitle, setModalTitle] = useState("Add New Item");
  const [targetGroupsData, setTargetGroupsData] = useState({
    genderOptions: [],
    lifeStageOptions: [],
    occupationOptions: [],
    maritalStatusOptions: [],
    incomeGroupOptions: [],
    tierOptions: [],
    regionOptions: [],
    stateOptions: [],
    wordLimitOptions: [],
    toneOptions: [],
    language: [],
  });
  const [messages, setMessages] = useState([]);
  const [objectId, setObjectId] = useState("");
  const [showMessages, setShowMessages] = useState(false);
  const marketingState = useSelector((state) => state.marketing);
  const dispatch = useDispatch();
  const [form] = Form.useForm()
  const [sessionModalVisible, setSessionModalVisible] = useState(false);
  const [marketingPage, setMarketingPage] = useState("");
  const [marketingCurrentNav, setMarketingCurrentNav] = useState(0);
  const { showCTATextArea, setShowCTATextArea } = useMarketingStore();
  const [inputText, setInputText] = useState("");
  const { setCtaResponseReceived, resetCtaResponse } = useMarketingStore();
  const location = useLocation();
  useEffect(() => {
    dispatch(setMarketingTabIndex(0));
    dispatch(setMarketingPages("SMS"));
  }, [])
  useEffect(() => {
    if (marketingState) {
      setMarketingPage(marketingState)
      setShowMessages(false)
      handleClear();
    }
  }, [marketingState])
  useEffect(() => {
    const fetchTargetGroupsData = async () => {
      try {
        const response = await dispatch(getTargetGroups());
        const data = response.payload ?.data;
        if (data) {
          setTargetGroupsData({
            genderOptions: data.gender ?.map(item => ({ value: item, label: item })) || [],
            lifeStageOptions: data.life_stage ?.map(item => ({ value: item, label: item })) || [],
            occupationOptions: data.occupation ?.map(item => ({ value: item, label: item })) || [],
            maritalStatusOptions: data.marital_status ?.map(item => ({ value: item, label: item })) || [],
            incomeGroupOptions: data.income_group ?.map(item => ({ value: item, label: item })) || [],
            tierOptions: data.tier ?.map(item => ({ value: item, label: item })) || [],
            regionOptions: data.region ?.map(item => ({ value: item, label: item })) || [],
            stateOptions: data.state ?.map(item => ({ value: item, label: item })) || [],
            wordLimitOptions: data.word_limit ?.map(item => ({ value: item, label: item })) || [],
            toneOptions: data.tone ?.map(item => ({ value: item, label: item })) || [],
            languageOptions: data.language ?.map(item => ({ value: item, label: item })) || [],
          });
        }
      } catch (error) {
        message.error("Failed to fetch target group data.");
        handleApiError(error)

      }
    };
    fetchTargetGroupsData();
  }, [dispatch]);

  const showSessionTimeoutModal = () => {
    setSessionModalVisible(true);
  };
  const handleApiError = (error) => {
    if (error ?.response ?.status === 401) {
      showSessionTimeoutModal();
    }
  };
  const onClear = () => {
    const resetFormData = {
      campaign: undefined,
      category: undefined,
      subCategory: undefined,
      gender: undefined,
      lifeStage: undefined,
      occupation: undefined,
      maritalStatus: undefined,
      incomeGroup: undefined,
      tier: undefined,
      region: undefined,
      state: undefined,
      wordLimit: undefined,
      tone: undefined,
      language: undefined,
      product_name: undefined,
      bs_text: undefined,
      behavioralScienceCheck: undefined,
    };
    setFormData(resetFormData);
    form.setFieldsValue(resetFormData);
  };

  const fetchCategoriesAndSubCategories = async (selectedCampaign) => {
    try {
      setLoading(true);
      const payload = { purpose: selectedCampaign };
      let response = await dispatch(getDropDownList(payload));
      const res = response.payload;

      if (response.error ?.message === "Rejected" || response.error) {
        setError("Something went wrong!! Please try again later");
      } else {
        const buckets = res.data.map((bucket) => ({
          value: bucket.bucket_name,
          label: bucket.bucket_name,
        }));
        setBucket(buckets);

        const newBucketMap = res.data.reduce((acc, bucket) => {
          acc[bucket.bucket_name] = {
            subcategories: bucket.sub_category.map((subcategory) => ({
              value: subcategory.name,
              label: subcategory.name,
              description: subcategory.desc,
            })),
          };
          return acc;
        }, {});
        setBucketMap(newBucketMap);
        setLoading(false);
      }
    } catch (error) {
      setError("Something went wrong!! Please try again later");
      setLoading(false);
      handleApiError(error)

    }
  };

  const handleCampaignChange = (value) => {
    setFormData({ ...formData, campaign: value, category: null, subCategory: null });
    form.setFieldsValue({ category: null, subCategory: null });
    fetchCategoriesAndSubCategories(value);
    if (value && formData.category && formData.subCategory) {
      setError("");
    }
  };

  const handleCategoryChange = (value) => {
    if (value === "Others") {
      setOthersBucketInput("");
      setOthersSubCategoryInput("");
      setOthersDesc("");
      setOthersType("bucket");
      setModalTitle("Add new Category");
      setModalVisible(true);
    }
    form.setFieldsValue({ category: value, subCategory: null });
    setFormData((prev) => ({ ...prev, category: value, subCategory: null }));
    setSubCategory([...(bucketMap[value] ?.subcategories || [])]);
    if (value && formData.campaign && formData.subCategory) {
      setError("");
    }
  };

  const handleSubCategoryChange = (value) => {
    //console.log(value, "value");
    if (value === "Others") {
      setOthersBucketInput("");
      setOthersSubCategoryInput("");
      setOthersDesc("");
      setOthersType("sub_category");
      setModalTitle("Add new Sub-Category");
      setModalVisible(true);
    }
    if (value && formData.campaign && formData.category) {
      setError("");
    }
    const selectedSubCategory = bucketMap[formData.category] ?.subcategories.find(
      (subcategory) => subcategory.value === value
    );
    setFormData((prev) => ({
      ...prev,
      subCategory: value,
      subCategoryDesc: selectedSubCategory ? selectedSubCategory ?.description : "",
    }));
    form.setFieldsValue({ subCategory: value });
  };

  const handleChange = (value, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  const validateInputs = () => {
    let newErrors = { bucket: "", subCategory: "", desc: "" };
    if (othersType === "bucket" && othersBucketInput.length > 50) {
      newErrors.bucket = "Category Name cannot exceed 50 characters";
    }
    if (othersSubCategoryInput.length > 50) {
      newErrors.subCategory = "Sub-Category Name cannot exceed 50 characters";
    }
    if (othersDesc.length > 1000) {
      newErrors.desc = "Description cannot exceed 1000 characters";
    }

    setErrors(newErrors);

    return !Object.values(newErrors).some((error) => error);
  };


  const handleAddOthers = async () => {
    if (validateInputs()) {
      if (!othersBucketInput && othersType === "bucket") {
        return message.error("Please enter a category name.");
      }
      if (!othersSubCategoryInput) {
        return message.error("Please enter a sub-category name.");
      }
      if (!othersDesc) {
        return message.error("Please enter a description.");
      }

      const payload = {
        purpose: formData.campaign,
        bucketName: othersBucketInput || formData.category,
        bucketDesc: "",
        subCategory: othersSubCategoryInput,
        subCategoryDesc: othersDesc,
        othersFlag: othersType,
      };

      try {
        const response = await dispatch(addNewFieldInDB(payload));
        if (response.error) {
          //console.log(response.error, "res");
          message.error(response.payload.response.data.message);
        } else {
          message.success("Category/Sub-Category added successfully!");
          fetchCategoriesAndSubCategories(formData.campaign);
          if (othersBucketInput) {
            handleCategoryChange(othersBucketInput)
            handleSubCategoryChange(othersSubCategoryInput)
            setFormData((prev) => ({
              ...prev,
              category: othersBucketInput,
              subCategory: othersSubCategoryInput,
              subCategoryDesc: othersDesc,
            }));
          } else {
            handleSubCategoryChange(othersSubCategoryInput)
            setFormData((prev) => ({
              ...prev,
              subCategory: othersSubCategoryInput,
              subCategoryDesc: othersDesc,
            }));
          }
          setModalVisible(false);
          setOthersBucketInput("");
          setOthersSubCategoryInput("");
          setOthersDesc("");
        }
      } catch (error) {
        //console.log(error, "error");
      }
    }
  };

  const onSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      if (values) {
        setGenerateLoading(true);
        setError("");
        setContent("");
        resetCtaResponse();



        let payload = {
          campaign: formData.campaign,
          category: formData.category,
          subCategory: formData.subCategory,
          description: formData.subCategoryDesc,
          prompt: content || "",
          type: marketingState.marketingTabIndex == 0 ? "sms" : marketingState.marketingTabIndex == 1 ? "subject" : "email",
          language: formData.language || "English",
          lifeStage: formData.lifeStage || "",
          gender: formData.gender || "",
          occupation: formData.occupation || "",
          maritalStatus: formData.maritalStatus || "",
          state: formData.state || "",
          incomeGroup: formData.incomeGroup || "",
          region: formData.region || "",
          tier: formData.tier || "",
          tone: formData.tone || "",
          wordLimit: formData.wordLimit || "",
          product_name: formData.product_name || "",
          bs_text: formData.bs_text || "",
          behavioralScienceCheck: formData.behavioralScienceCheck || false,


        };

        const response = await dispatch(getPromptResponse(payload));
        if (response.error) {
          setError("Please select Campaign!");
        } else {
          const raw = response.payload ?.data ?.response;
          setObjectId(response.payload ?.data ?.objectId);

          // Store the full response object (answer, reason, tags)
          setMessages(raw);

          setShowMessages(true);
          setGenerateLoading(false);
        }
      }
    } catch (error) {
      setGenerateLoading(false);
      handleApiError(error)

    } finally {
      setLoading(false);
    }
  };
  const handelUpdatedShowMessage = () => {
    setShowMessages(false);
  }

  const handleCTAResponse = async () => {
    setGenerateLoading(true);

    const HTML_TAG_REGEX = /<[^>]+>/;
    const scriptTagRegex = /<script\b[^>]*>([\s\S]*?)?(<\/script>)?/i;
    const specialCharRegex = /[^a-zA-Z0-9\s]/; // Disallow special characters (except spaces)

    if (!inputText.trim()) {
      setGenerateLoading(false);
      message.error("CTA text cannot be empty.");
      return;
    }

    if (inputText.length > 500) {
      setGenerateLoading(false);
      message.error("Input exceeds 500 characters. Please shorten your text.");
      return;
    }

    if (scriptTagRegex.test(inputText) || HTML_TAG_REGEX.test(inputText)) {
      setGenerateLoading(false);
      message.destroy();
      message.error("Invalid input");
      return;
    }

    if (specialCharRegex.test(inputText)) {
      setGenerateLoading(false);
      message.error("Invalid input: Special characters are not allowed.");
      return;
    }

    const requestData = {
      type: "cta",
      prompt: inputText,
    };

    try {
      const response = await dispatch(getCTAResponse(requestData));
      const raw = response.payload ?.data ?.response;
      const messagesOnly = Array.isArray(raw)
        ? raw.filter(item => typeof item === "string" && item.trim() !== "")
        : (raw != null ? [String(raw)] : []);
      if (messagesOnly.length) {
        setCtaResponseReceived(true);
        setMessages(messagesOnly);
        setShowMessages(true);
      } else {
        message.error("Failed to generate content.");
      }

    } catch (error) {
      console.error("Error generating CTA:", error);
    } finally {
      setGenerateLoading(false);
    }
  };


  const handleGenerate = () => {
    if (showCTATextArea) {
      handleCTAResponse();
    } else {
      onSubmit();
    }
  };

  const handleClear = () => {
    if (showCTATextArea) {
      setInputText(""); // Clear textarea content
    } else {
      onClear(); // Existing clear function
    }
  };

  const handleCTAClick = (tabIndex, page) => {
    if (tabIndex === 3) {
      // Show CTA Text Area if Generate CTAs is clicked
      setShowCTATextArea(true);
    } else {
      // Hide CTA Text Area if any other tab is clicked
      setShowCTATextArea(false);
    }
    // Update the tab and page as usual
    handleMarketingNavUpdate(tabIndex, page);
  };

  const handleMarketingNavUpdate = (tabIndex, page) => {
    // localStorage.setItem("marketingTab",tabIndex)
    dispatch(setMarketingTabIndex(tabIndex));
    dispatch(setMarketingPages(page));

    setMarketingCurrentNav(tabIndex);
  };

  const handleDropdownChange = (value) => {
    const selectedOption = marketingOptions.find(opt => opt.value === value);
    if (selectedOption) {
      handleCTAClick(selectedOption.value, selectedOption.page);
    }
  };

  const iconStyle = {
    display: "flex",
    fontSize: 16,  // Smaller than default
    marginRight: 8,
    color: '#555'
  };

  const marketingOptions = [
    {
      label: "Generate SMS",
      value: 0,
      page: "SMS",
      icon: <AddCommentOutlinedIcon style={iconStyle} />,
    },
    {
      label: "Generate Subject Line",
      value: 1,
      page: "Subject Line",
      icon: <AssistantOutlinedIcon style={iconStyle} />,
    },
    {
      label: "Generate Email",
      value: 2,
      page: "Email",
      icon: <AttachEmailIcon style={iconStyle} />,
    },
    {
      label: "Generate CTAs",
      value: 3,
      page: "CTA",
      icon: <AddCircleOutlineOutlinedIcon style={iconStyle} />,
    },
  ];

  const productListOptions = [
    { value: 'HDFC Life YoungStar Udaan', label: 'HDFC Life YoungStar Udaan' },
    { value: 'HDFC Life Saral Jeevan', label: 'HDFC Life Saral Jeevan' },
    { value: 'HDFC Life Systematic Retirement Plan', label: 'HDFC Life Systematic Retirement Plan' },
    { value: 'HDFC Life ProGrowth - Flexi', label: 'HDFC Life ProGrowth - Flexi' },
    { value: 'HDFC Life Cardiac Care', label: 'HDFC Life Cardiac Care' },
    { value: 'HDFC Life Sampoorna Jeevan', label: 'HDFC Life Sampoorna Jeevan' },
    { value: 'HDFC Life Click 2 Protect Super', label: 'HDFC Life Click 2 Protect Super' },
    { value: 'HDFC Life Click 2 Wealth', label: 'HDFC Life Click 2 Wealth' },
    { value: 'HDFC Life Super Income Plan', label: 'HDFC Life Super Income Plan' },
    { value: 'HDFC Life Guaranteed Savings Plan', label: 'HDFC Life Guaranteed Savings Plan' },
    { value: 'HDFC Life Sanchay Legacy', label: 'HDFC Life Sanchay Legacy' },
    { value: 'HDFC Life Sanchay Par Advantage', label: 'HDFC Life Sanchay Par Advantage' },
    { value: 'HDFC Life Sampoorn Nivesh', label: 'HDFC Life Sampoorn Nivesh' },
    { value: 'HDFC Life Smart Woman Plan', label: 'HDFC Life Smart Woman Plan' },
    { value: 'HDFC Life Sanchay Fixed Maturity Plan', label: 'HDFC Life Sanchay Fixed Maturity Plan' },
    { value: 'HDFC Life Personal Pension Plus', label: 'HDFC Life Personal Pension Plus' },
    { value: 'HDFC Life Classic Assure Plus', label: 'HDFC Life Classic Assure Plus' },
    { value: 'HDFC Life Smart Pension Plus', label: 'HDFC Life Smart Pension Plus' },
    { value: 'HDFC Life Classic One', label: 'HDFC Life Classic One' },
    { value: 'HDFC Life ProGrowth Super II', label: 'HDFC Life ProGrowth Super II' },
    { value: 'HDFC Life Systematic Pension Plan', label: 'HDFC Life Systematic Pension Plan' },
    { value: 'HDFC Life Pension Guaranteed Plan', label: 'HDFC Life Pension Guaranteed Plan' },
    { value: 'HDFC Life Crest', label: 'HDFC Life Crest' },
    { value: 'HDFC Life YoungStar Super premium', label: 'HDFC Life YoungStar Super premium' },
    { value: 'HDFC Life Sanchay Plus', label: 'HDFC Life Sanchay Plus' },
    { value: 'HDFC Life Click 2 Protect Life', label: 'HDFC Life Click 2 Protect Life' },
    { value: 'HDFC Life Saral Pension', label: 'HDFC Life Saral Pension' },
    { value: 'HDFC Life Sampoorn Samridhi plus', label: 'HDFC Life Sampoorn Samridhi plus' },
    { value: 'HDFC Life Smart Protect Plan', label: 'HDFC Life Smart Protect Plan' },
    { value: 'HDFC Life ProGrowth Plus', label: 'HDFC Life ProGrowth Plus' },
    { value: 'HDFC Life Click 2 Achieve', label: 'HDFC Life Click 2 Achieve' },
    { value: 'HDFC Life Guaranteed wealth Plus', label: 'HDFC Life Guaranteed wealth Plus' },
    { value: 'HDFC Life Saral Jeevan Bima', label: 'HDFC Life Saral Jeevan Bima' },
    { value: 'HDFC Life Capital Shield', label: 'HDFC Life Capital Shield' },
    { value: 'HDFC Life Guaranteed Income Insurance Plan', label: 'HDFC Life Guaranteed Income Insurance Plan' },
    { value: 'HDFC Life Click 2 Protect Elite', label: 'HDFC Life Click 2 Protect Elite' },
    { value: 'HDFC Life C2I-N-Sanchay Fixed Maturity Plan', label: 'HDFC Life C2I-N-Sanchay Fixed Maturity Plan' },
    { value: 'HDFC Life New immediate annuity', label: 'HDFC Life New immediate annuity' },
    { value: 'HDFC Life Assured Pension Plan', label: 'HDFC Life Assured Pension Plan' },
    { value: 'HDFC Life Smart Pension Plan', label: 'HDFC Life Smart Pension Plan' },
    { value: 'HDFC Life Click 2 Invest', label: 'HDFC Life Click 2 Invest' },
    { value: 'HDFC Life Cancer Care', label: 'HDFC Life Cancer Care' }
  ];


  return (
    <>
      <div className="heading-div">
        <div>
          <p className="text5">
            {getTitleFromPath(location ?.pathname)}
          </p>
        </div>
        <div className="marketing-options-div">
          <Select
            style={{ width: 210 }}
            value={marketingCurrentNav}
            onChange={handleDropdownChange}
          >
            {marketingOptions.map((opt) => (
              <Option key={opt.value} value={opt.value}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span className="marketing-icon">
                    {opt.icon}
                  </span>
                  <span>{opt.label}</span>
                </div>
              </Option>
            ))}
          </Select>
        </div>
      </div>
      <div style={{ padding: "20px 0px", height: "100vh" }}>
        {(loading || generateLoading) && <div className="loader"><img className="gif-marketing" src={loader} alt="loading..." /></div>}
        <Form form={form} // Use the form hook here
          layout="vertical"
          initialValues={formData}>
          {showMessages ? (
            <MessageTab
              apiData={{ data: { response: messages, objectId } }}
              loading={loading}
              onSubmit={onSubmit}
              updateShowMessages={handelUpdatedShowMessage}
              marketingPage={marketingPage}
              objectId={objectId}
              handleCTAResponse={handleCTAResponse}
            />

          ) : (
              <div
                className="marketing-message-tab"
              > {showCTATextArea ? (
                <>
                  <div className="marketing-head"><h3>{"Generate  " + marketingState.marketingPage}</h3></div>
                  <textarea
                    style={{
                      width: '100%',
                      height: '60px',
                      marginTop: '0px',
                      padding: '10px',
                      fontSize: '12px',
                      borderRadius: '6px',
                      border: '1px solid #ddd',
                      resize: 'none', // Disable resizing
                      marginBottom: "10px",
                    }}
                    value={inputText}
                    onChange={(e) => setInputText(e.target.value)}
                    placeholder="Enter your instructions here"
                  />
                </>
              ) : (
                  <div className="marketing-scrollable-div" style={{ scrollbarWidth: "thin" }}>
                    <div>
                      <div className="marketing-head"><h3>{"Generate  " + marketingState.marketingPage}</h3></div>
                      <div className="marketing-head-options" style={{ marginBottom: "10px" }}>
                        <Form.Item label="Campaign" name="campaign" className="marketing-head-options-select" rules={[{ required: true, message: "Please select a campaign" }]}>
                          <Select
                            options={campaignOptions}
                            onChange={handleCampaignChange}
                            value={formData.campaign}
                            placeholder="Select a campaign"
                          />
                        </Form.Item>

                        <Form.Item label="Category" name="category" className="marketing-head-options-select" rules={[{ required: true, message: "Please select a category" }]}>
                          <Select
                            showSearch
                            placeholder="Select a category"
                            optionFilterProp="label"
                            options={[...bucket, { value: "Others", label: "Others" }]}
                            onChange={handleCategoryChange}
                            value={formData.category || undefined}
                            disabled={!formData.campaign}
                          />
                        </Form.Item>

                        <Form.Item label="Sub Category" name="subCategory" className="marketing-head-options-select" rules={[{ required: true, message: "Please select a sub-category" }]}>
                          <Select
                            showSearch
                            placeholder="Select a sub-category"
                            optionFilterProp="label"
                            options={[...subCategory, { value: "Others", label: "Others" }]}
                            onChange={handleSubCategoryChange}
                            value={formData.subCategory}
                            disabled={!formData.category}
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="marketing-head-options">

                      {/* Behavioral Science Toggle */}
                      <Form.Item
                        label="Behavioral Science"
                        name="behavioralScienceCheck"
                        className="marketing-head-options-select"
                      >
                        <Select
                          value={formData.behavioralScienceCheck ? "yes" : "no"}
                          onChange={(value) =>
                            handleChange(value === "yes", "behavioralScienceCheck")
                          }
                          placeholder="Select an option"
                        >
                          <Select.Option value="yes">Yes</Select.Option>
                          <Select.Option value="no">No</Select.Option>
                        </Select>
                      </Form.Item>



                      {/* Behavioral Science Input Field */}
                      <Form.Item
                        label="Additional Info"
                        name="bs_text"
                        className="marketing-head-options-select"
                      >
                        <Input
                          value={formData.bs_text}
                          onChange={(e) => handleChange(e.target.value, 'bs_text')}
                          placeholder="Enter additional information"
                          style={{ borderRadius: "6px", height: "31px" }}
                        />
                      </Form.Item>

                      {/* Product List Dropdown */}
                      <Form.Item
                        label="Product Name"
                        name="product_name"
                        className="marketing-head-options-select"
                      >
                        <Select
                          options={productListOptions}
                          onChange={(value) => handleChange(value, 'product_name')}
                          value={formData.product_name}
                          placeholder="Select a product"
                        />
                      </Form.Item>


                    </div>

                    {error && <div className="error-message" style={{ color: 'red', marginBottom: '12px', marginTop: "-16px", marginLeft: "1rem" }}>{error}</div>}


                    <div>
                      <div className="marketing-subHead"><h4>Target Groups</h4></div>


                      <div className="marketing-head-options">

                        <Form.Item label="Gender" className="marketing-head-options-select" >
                          <Select
                            options={targetGroupsData.genderOptions}
                            onChange={(value) => handleChange(value, 'gender')}
                            value={formData.gender}
                          />
                        </Form.Item>

                        <Form.Item label="Life Stage" className="marketing-head-options-select">
                          <Select
                            options={targetGroupsData.lifeStageOptions}
                            onChange={(value) => handleChange(value, 'lifeStage')}
                            value={formData.lifeStage}
                          />
                        </Form.Item>

                        <Form.Item label="Occupation" className="marketing-head-options-select">
                          <Select
                            options={targetGroupsData.occupationOptions}
                            onChange={(value) => handleChange(value, 'occupation')}
                            value={formData.occupation}
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="marketing-head-options">
                      <Form.Item label="Marital Status" className="marketing-head-options-select">
                        <Select
                          options={targetGroupsData.maritalStatusOptions}
                          onChange={(value) => handleChange(value, "maritalStatus")}
                          value={formData.maritalStatus}
                        />
                      </Form.Item>
                      <Form.Item label="Income Group" className="marketing-head-options-select">
                        <Select
                          options={targetGroupsData.incomeGroupOptions}
                          onChange={(value) => handleChange(value, "incomeGroup")}
                          value={formData.incomeGroup}
                        />
                      </Form.Item>
                      <Form.Item label="Tier" className="marketing-head-options-select">
                        <Select
                          options={targetGroupsData.tierOptions}
                          onChange={(value) => handleChange(value, "tier")}
                          value={formData.tier}
                        />
                      </Form.Item>
                    </div>
                    <div className="marketing-head-options">
                      <Form.Item label="Region" className="marketing-head-options-select">
                        <Select
                          options={targetGroupsData.regionOptions}
                          onChange={(value) => handleChange(value, "region")}
                          value={formData.region}
                        />
                      </Form.Item>
                      <Form.Item label="State" className="marketing-head-options-select">
                        <Select
                          options={targetGroupsData.stateOptions}
                          onChange={(value) => handleChange(value, "state")}
                          value={formData.state}
                        />
                      </Form.Item>
                      <Form.Item label="Character Limit" className="marketing-head-options-select">
                        <Select
                          options={targetGroupsData.wordLimitOptions}
                          onChange={(value) => handleChange(value, "wordLimit")}
                          value={formData.wordLimit}
                        />
                      </Form.Item>
                    </div>
                    <div className="marketing-head-options">
                      <Form.Item label="Tone" className="marketing-head-options-select" >
                        <Select
                          options={targetGroupsData.toneOptions}
                          onChange={(value) => handleChange(value, 'tone')}
                          value={formData.tone}

                        // style={{ width: marketingPage ?.marketingPage == "SMS" ? "100%" : "32%"}}
                        />
                      </Form.Item>
                      {marketingPage ?.marketingPage == 'SMS' &&
                        <Form.Item label="Language" className="marketing-head-options-select">
                          <Select
                            options={targetGroupsData.languageOptions}
                            onChange={(value) => handleChange(value, 'language')}
                            value={formData.language}

                          />
                        </Form.Item>
               }

                      {marketingPage ?.marketingPage == 'SMS' &&
                        <>
                          <Form.Item label="Language" className="marketing-head-options-select" style={{ visibility: 'hidden' }}>
                            <Select
                              disabled
                            />
                          </Form.Item>
                        </>
               }

                      {marketingPage ?.marketingPage !== 'SMS' &&
                        <>
                          <Form.Item label="Language" className="marketing-head-options-select" style={{ visibility: 'hidden' }}>
                            <Select
                              disabled
                            />
                          </Form.Item>
                          <Form.Item label="Language" className="marketing-head-options-select" style={{ visibility: 'hidden' }}>
                            <Select
                              disabled
                            />
                          </Form.Item>
                        </>
               }
                    </div>
                  </div>
                )}
                <div className="marketing-buttons">
                  <Button
                    type="text"
                    onClick={handleClear}
                  >
                    Clear
                </Button>

                  <Button
                    type="primary"
                    onClick={handleGenerate}
                  >
                    Generate
                </Button>
                </div>

              </div>

            )}
        </Form>

        <Modal
          title={modalTitle}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={null}
          style={{ height: "auto", borderRadius: "0px" }}
        >
          <>
            {othersType === "bucket" && (
              <>
                <Input
                  placeholder="Enter Category Name"
                  value={othersBucketInput}
                  onChange={(e) => {
                    setOthersBucketInput(e.target.value)
                    setErrors((prevErrors) => ({ ...prevErrors, bucket: "" }))
                  }
                  }
                  style={{
                    marginTop: 15,
                    borderRadius: "4px",
                    height: "30px",
                    fontSize: "14px",

                  }}
                />
                {errors.bucket && <div style={{ color: "red", fontSize: "12px", marginTop: 2 }}>{errors.bucket}</div>}
              </>
            )}
          </>

          <Input
            placeholder="Enter Sub-Category Name"
            value={othersSubCategoryInput}
            onChange={(e) => {
              setErrors((prevErrors) => ({ ...prevErrors, subCategory: "" }));
              setOthersSubCategoryInput(e.target.value)
            }}
            style={{
              marginTop: 15,
              borderRadius: "4px",
              height: "30px",
              fontSize: "14px",
            }}
          />
          {errors.subCategory && (
            <div style={{ color: "red", fontSize: "12px", marginTop: 2 }}>
              {errors.subCategory}
            </div>
          )}

          <TextArea
            placeholder="Enter Description"
            value={othersDesc}
            onChange={(e) => {
              setOthersDesc(e.target.value)
              setErrors((prevErrors) => ({ ...prevErrors, desc: "" }));
            }
            }
            style={{
              marginTop: 15,
              borderRadius: "4px",
              height: "120px",
              fontSize: "14px",
              resize: "none",
            }}
          />
          {errors.desc && (
            <div style={{ color: "red", fontSize: "12px", marginTop: 2 }}>
              {errors.desc}
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15, }}>
            <Button type="primary" onClick={handleAddOthers}>
              Add
                    </Button>
          </div>


        </Modal>

        <SessionTimeoutModal visible={sessionModalVisible} />
      </div>
    </>
  );
};

export default Marketing;
